import PropTypes from 'prop-types';
import { MaintenanceStatusEnums, PlatformStatusEnums } from './enums';

export const PlatformPropType = PropTypes.shape({
	id: PropTypes.string,
	code: PropTypes.string,
});

export const RolePropType = PropTypes.shape({
	name: PropTypes.string,
	id: PropTypes.string,
	platforms: PropTypes.arrayOf(PlatformPropType),
});

export const GroupPropType = PropTypes.arrayOf(PropTypes.shape({
	id: PropTypes.string,
	name: PropTypes.string,
}));

export const CertificatePropType = PropTypes.shape({
	version: PropTypes.string,
	key: PropTypes.string,
	ib: PropTypes.string,
});

export const OptionPropType = PropTypes.arrayOf(PropTypes.shape({
	label: PropTypes.string,
	value: PropTypes.string,
}));

export const MaintenancePropType = PropTypes.shape({
	status: PropTypes.oneOf(Object.values(MaintenanceStatusEnums)),
	alertInServingConversationMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	announcement: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
});

export const PlatformStatusPropType = PropTypes.shape({
	id: PropTypes.string,
	status: PropTypes.oneOf(Object.values(PlatformStatusEnums)),
});
